import React from 'react';
import styled from 'styled-components';
import { CERULEAN } from '../../@style/colors';

interface Props {
  children: React.ReactNode;
  checked: boolean;
  onClick: () => void;
}

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  margin-top: 30px;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div<any>`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background: ${(props) => (props.checked ? 'red' : 'green')}
  border-radius: 5px;
  border: 2px solid ${CERULEAN};
  cursor: pointer;
  transition: all 150ms;
  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px pink;
  }
  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')}
  }
`;

const CheckBox: React.FC<Props> = ({ children, checked, onClick, ...rest }) => {
  return (
    <CheckboxContainer onClick={onClick}>
      <HiddenCheckbox {...rest} />
      <StyledCheckbox checked={checked} {...rest}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
      {children}
    </CheckboxContainer>
  );
};

export default CheckBox;
